const unidadesSAT = {
  "Unidad de servicio": "E48",
  Viaje: "E54",
  Hora: "HUR",
  Litro: "LTR",
  "Tonelada de carga": "A75",
  Pieza: "H87",
  Kilogramos: "KGM",
  Caja: "XBX",
  Pulgada: "INH",
  Centilitro: "CLT",
  "Centímetro cuadrado": "CMK",
  "Centímetro cúbico": "CMQ",
  Día: "DAY",
  "Metro cuadrado": "MTK",
  "Metro cúbico": "MTQ",
  Metro: "MTR",
  Yarda: "YRD",
  Centímetro: "CMT",
  Carrete: "XRL",
  Rollo: "XRO",
  Pie: "FOT",
  "Pie cuadrado": "FTK",
  "Pie cúbico": "FTQ",
  Gramo: "GRM",
  Hectárea: "HAR",
  "Pulgada cuadrada": "INK",
  "Pulgada cúbica": "INQ",
  "Yarda cuadrada": "YDK",
  "Yarda cúbica": "YDQ",
  Equipos: "11",
  Vehículo: "NV",
  Unidad: "XUN",
  Uno: "C62",
  Paquete: "XPK",
  Cubeta: "XBJ",
  Saco: "XSA",
  Cartucho: "XCQ",
  "Conteo en cientos": "XCN",
  Galón: "A76",
  "Kit": "XKI",
  Mil: "MIL",
  "Tonelada": "TNE",
};

export default unidadesSAT;
